import type { AboutBuildInfo } from '../../components/scenarios/about/types'

import posthog from 'posthog-js'

import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useBuildInfo } from '../../composables'

export const useSharedAnalyticsStore = defineStore('analytics-shared', () => {
  const buildInfo = ref<AboutBuildInfo>(useBuildInfo())
  const isInitialized = ref(false)

  const appStartTime = ref<number | null>(null)
  const firstMessageTracked = ref(false)
  const stageOpenedTracked = ref(false)
  const voiceUsedTracked = ref(false)
  const roundsTracked = ref(0)

  function initialize() {
    if (isInitialized.value)
      return

    appStartTime.value = Date.now()

    // Register metadata with PostHog after buildInfo is set
    posthog.register({
      app_version: (buildInfo.value.version && buildInfo.value.version !== '0.0.0') ? buildInfo.value.version : 'dev',
      app_commit: buildInfo.value.commit,
      app_branch: buildInfo.value.branch,
      app_build_time: buildInfo.value.builtOn,
    })

    const today = new Date().toISOString().slice(0, 10)
    const lastVisit = globalThis.localStorage?.getItem('mouly:last-visit-date') || ''
    if (lastVisit && lastVisit !== today) {
      posthog.capture('d1_revisit', {
        previous_visit_date: lastVisit,
        current_visit_date: today,
      })
    }
    globalThis.localStorage?.setItem('mouly:last-visit-date', today)

    isInitialized.value = true
  }

  function markFirstMessageTracked() {
    firstMessageTracked.value = true
  }

  function markStageOpenedTracked() {
    stageOpenedTracked.value = true
  }

  function markVoiceUsedTracked() {
    voiceUsedTracked.value = true
  }

  function setRoundsTracked(rounds: number) {
    roundsTracked.value = rounds
  }

  return {
    buildInfo,
    appStartTime,
    firstMessageTracked,
    stageOpenedTracked,
    voiceUsedTracked,
    roundsTracked,
    initialize,
    markFirstMessageTracked,
    markStageOpenedTracked,
    markVoiceUsedTracked,
    setRoundsTracked,
  }
})
